import axios from 'axios';

const basePath = process.env.REACT_APP_BASE_PATH || '/ypo-gold-istanbul';
const apiUrl = process.env.REACT_APP_API_URL || `${basePath}/api`;

// Ensure HTTPS is used in production
const getBaseURL = () => {
  // If we're on HTTPS, ensure the API URL is also HTTPS
  if (window.location.protocol === 'https:') {
    // If apiUrl is a relative path, prepend with the current origin
    if (apiUrl.startsWith('/')) {
      return `${window.location.origin}${apiUrl}`;
    }
    // If it's already a full URL with http://, replace with https://
    return apiUrl.replace(/^http:/, 'https:');
  }
  // For local development, use the apiUrl as is
  return apiUrl;
};

const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = `${basePath}/login`;
    }
    return Promise.reject(error);
  }
);

export default api;
export { basePath };
